import { FunctionComponent } from 'react'
import PageWrapper from 'hoc/PageWrapper'
import { useUserCurrentQuery } from 'services/users'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { Divider, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { EOrganizationType } from 'types/users'
import { useTendersDashboardDataQuery } from 'services/tender'
import { DashboardGeneralInfo } from './dashboard-general-info'
import { DashboardChartCalendar } from './dashboard-chart-calendar-box'
import { DashboardContestList } from './dashboard-contest-list'

export const Dashboard: FunctionComponent = () => {
  const { t } = useTranslation()
  const {
    data: currentUser,
    isLoading: isUserLoading,
    isError: isUserError,
  } = useUserCurrentQuery()

  const {
    data: dashboardData,
    isLoading: isDashboardDataLoading,
    isError: isDashboardDataError,
  } = useTendersDashboardDataQuery()

  const canSeeLists = currentUser?.organizationType === EOrganizationType.CLIENT

  if (isUserLoading || isDashboardDataLoading) {
    return <Loading fullPage={false} />
  }
  if (isUserError || isDashboardDataError) {
    return <Error fullPage={false} />
  }
  if (currentUser === undefined || dashboardData === undefined) {
    return <></>
  }

  return (
    <PageWrapper>
      <Typography fontWeight="bold" variant="h6">
        {t('home')}
      </Typography>
      <Divider flexItem />
      <DashboardGeneralInfo dashboardData={dashboardData} />
      <DashboardChartCalendar dashboardData={dashboardData} />
      {canSeeLists && <DashboardContestList />}
    </PageWrapper>
  )
}
